import {call, put, takeEvery} from 'redux-saga/effects'

import {ADD_CLIENT_REQUESTED, GET_COUNTRY_REQUESTED} from '../actions/actionTypes'
import {addClientSuccess, getCountryFailed, getCountrySuccess, returnFailed} from '../actions/clientAddAction'
import {messages} from '../../helpers/messages'
import {clientService} from '../../services/client-service'
import {cashBoxService} from '../../services/cashbox-service'

export const methods = {
  convertAddress: (addresses) => {
    addresses.forEach(address => {
      if (address.city?.label) {
        address.city = address.city?.name;
        address.street = address.street?.name;
        address.region = address.region?.value;
      }
      if(!address.soato){
        address.soato = null;
      }
    })
    return addresses
  },
  mapDataToRequest: (form, state) => {
    let data = {
      clientRequestInfoBean: {
        ...form.client,
        clientDocumentInfoBeanList: state.documents,
        clientContactInfoBeanList: state.contacts,
        clientAddressInfoBeanList: methods.convertAddress(state.addresses),
        serviceInformation: state.serviceInformation,
      },
      expandedClientRequestInfo: {}
    }
    if (state.expanded) {
      data.expandedClientRequestInfo = {
        ...form.expanded,
        employerInfoBeans: state.employers,
        entryVisaInfoBeanList: state.entryVisas,
        previousLastNameBeanList: state.previousLastNames,
        representativesInfoBeanList: state.representatives,
        ieInfoBeans: state.individualEntrepreneurs,
        decisionMakersInfo: state.decisionMakersInfo[0]?.decisionMakersInfo
      };
    }
    return data
  }
}

const postClient = async ({form, state}) => {
  let data = methods.mapDataToRequest(
    {...form, client: {...form.client, citizenship: form.client.citizenship.label}},
    state)

  return await clientService
    .createClient(data)
    .then(({data: {client}}) => client)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })
}

const getCountry = async (data) =>
  await cashBoxService
    .getCountries(data)
    .then(({data: {words}}) => words.map(c => ({value: c.id, label: `${c.name[0]}${c.name.slice(1).toLowerCase()}`})))
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

function* fetchAddClient (action) {
  try {
    const client = yield call(() => postClient(action))
    yield put(addClientSuccess(client))
  } catch (error) {
    yield put(returnFailed(error))
  }
}

function* fetchGetCountry (action) {
  try {
    const country = yield call(() => getCountry(action.payload))
    yield put(getCountrySuccess(country))
  } catch (error) {
    yield put(getCountryFailed(error))
  }
}

function* addClientSaga () {
  yield takeEvery(ADD_CLIENT_REQUESTED, fetchAddClient)
}

function* getCountrySaga () {
  yield takeEvery(GET_COUNTRY_REQUESTED, fetchGetCountry)
}

export {
  addClientSaga,
  getCountrySaga
}
